import {getElement, getElements, ifSelectorExist } from './utils';

export const readMore = () => {
    let btn = getElement('.read-more');
    let hiddenText = getElement('.hidden-text')

    if (ifSelectorExist(btn) && ifSelectorExist(hiddenText)) {
        btn.addEventListener('click', () => {
            hiddenText.classList.toggle('hidden');
    
            if (!hiddenText.classList.contains('hidden')) {
                btn.innerText = 'read less'
            } else {
                btn.innerText = 'read more...'
            }
        })
    }
}

export const loadMore = () => {
    let btn = getElement('.load-more');
    let hiddenItems = getElements('.review-items.hidden')

    if (ifSelectorExist(btn) && ifSelectorExist(hiddenItems)) {
        btn.addEventListener('click', () => {
            hiddenItems.forEach(element => {
                element.classList.remove('hidden');
            });

            btn.remove();
        })
    }
}

export const showMorePrograms = () => {
    let programIitemsWrapper = getElements('.program_items_wrapper');

    if (ifSelectorExist(programIitemsWrapper)) {
        Array.from(programIitemsWrapper).forEach(e => {
            let programItems = e.querySelectorAll('.custom-list.programs ul li'),
                btns = e.querySelectorAll('.show-more-programs');

            if (programItems.length <= 7) {
                btns.forEach(btn => {
                    btn.classList.add('hidden');
                });
            }

            programItems.forEach((element, index) => {
                if (index >= 7) {
                    element.classList.add('hidden');
                }
            });

            Array.from(btns).forEach(e => {
                e.addEventListener('click', () => {
                    programItems.forEach((item, index) => {
                        if (index >= 7) {
                            item.classList.toggle('hidden');
                        }

                        if (item.classList.contains('hidden')) {
                            e.textContent = 'show more...';
                        } else {
                            e.textContent = 'show less';
                        }
                    });
                })
            })
        })  
    }
}

export const loadMoreReview = () => {
    if (window.innerWidth <= 768) {
        let textContainers = document.querySelectorAll('.review-loadmore-mob');
        let maxLength = 280;

        textContainers.forEach(container => {
            let text = container.textContent.trim();

            if (text.length > maxLength) {
                let truncatedText = text.substring(0, maxLength);
                let remainingText = text.substring(maxLength);

                let showMoreButton = document.createElement('button');
                showMoreButton.textContent = 'Show More';
                showMoreButton.onclick = function () {
                    container.textContent = truncatedText + remainingText;
                    showMoreButton.style.display = 'none';
                };

                container.textContent = truncatedText + '... ';
                container.appendChild(showMoreButton);
            }
        });
    }
};